export default function AbyssHeading({lang = 'zh-Hant'}) {
  const english = lang === 'en';

  return (
    <header className="abyss-heading">
      <span>03 · SHUN NO FUCHI · 旬之淵</span>
      <h2 id="abyss-title">
        {english
          ? 'Descend Through 100 Floors of Seasonal Flavors and Forgotten Memories'
          : '深入旬之淵百層，尋回季節鮮味與被遺忘的料理記憶'}
      </h2>
      <p>
        {english
          ? 'Explore one hundred distinct oke worlds, each with its own ecology, seasonal ingredients, guardians and recoverable specimens preserved beneath the water.'
          : '探索一百個各自成界的壽司桶宇宙。每一層都有獨特生態、當旬食材、守護者與可回收標本，封存著一期一會的鮮味與板前記憶。'}
      </p>
    </header>
  );
}